import {Component} from '@angular/core';

@Component({
    selector: 'app-cars-current',
    templateUrl: './cars-current.component.html',
    styleUrl: './cars-current.component.scss'
})
export class CarsCurrentComponent {

}
